module.exports = __webpack_public_path__ + "img/97.2263fb9a.png";